module.exports = __webpack_public_path__ + "static/assets/e5ea372102f2e93f6844603097be6334.svg";